import React from 'react';
import { Outlet } from 'react-router-dom';

const NewsHome = () => (
  <section className="app-route">
    <Outlet />
  </section>
);

export default NewsHome;